export default {
  namespaced: true,
  billing_holiday: {
    title: "Férias",
    date: "Data",
  }
}